module.exports = __webpack_public_path__ + "static/img/amg-2.dee9716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/amg-2.jpg
// module id = bI/Y
// module chunks = 1